import Seo from "@/components/Seo";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQS = [
  {
    q: "Wat is CheckExpert?",
    a: "CheckExpert is een onafhankelijk platform dat 19 soorten documenten doorlicht voor particulieren in België en Nederland: huurcontracten, verzekeringspolissen, loonstroken, arbeidscontracten, krediet, bouwrapporten, scheidingsakkoorden en meer. Wij vergelijken jouw document met de actuele BE/NL wetgeving en marktstandaarden.",
  },
  {
    q: "Hoe nauwkeurig is de analyse?",
    a: "We werken met de actuele Belgische en Nederlandse wetgeving en gangbare marktstandaarden. Per check is er een specifieke context (huurrecht, arbeidsrecht, consumentenrecht, zorgrecht, etc.). De analyse is een sterke eerste lezing — bij grote bedragen of complexe geschillen raden we aan om bij twijfel een specialist (advocaat, accountant, notaris, zorgadviseur…) te raadplegen.",
  },
  {
    q: "Welke documenten ondersteunen jullie?",
    a: "PDF, Word (.docx), foto's (JPG, PNG, WEBP) tot 15 MB, of getypte tekst. Bij sommige checkers (PolisCheck, EnergieCheck) kan je ook gewoon je situatie typen.",
  },
  {
    q: "Wat gebeurt er met mijn gegevens?",
    a: "Documenten en analyses worden 30 dagen bewaard zodat je terug kan inloggen op je rapport. Daarna worden ze automatisch verwijderd. We delen nooit je documenten met derden. Lees ons privacybeleid voor meer details.",
  },
  {
    q: "Vervangt CheckExpert een specialist?",
    a: "Nee — CheckExpert is een eerste, onafhankelijke leesvenster. Het helpt je risico's herkennen, vragen formuleren en weten wanneer je écht een specialist (advocaat, accountant, notaris, zorgadviseur of andere expert) nodig hebt.",
  },
  {
    q: "Hoe wordt de score berekend?",
    a: "De score (0–100) is een gewogen samenvatting van het aantal en de zwaarte van de bevindingen: kritiek (-25), hoog (-15), aandacht (-8), info (-2), oké (+0). 100 is perfect.",
  },
  {
    q: "Werken jullie samen met aanbieders of tussenpersonen?",
    a: "Nee. We zijn volledig onafhankelijk en hebben geen commerciële banden met aannemers, banken, verzekeraars, energieleveranciers of vakbonden. Het rapport is daarom neutraal.",
  },
  {
    q: "Voor wie zijn de checks bedoeld?",
    a: "Voor particulieren. Bedrijven, KMO's en zelfstandigen mogen het gebruiken maar de juridische context is geijkt op consumentenbescherming.",
  },
];

export default function Faq() {
  return (
    <div className="max-w-3xl mx-auto px-6 py-20" data-testid="faq-page">
      <Seo path="/faq" />
      <div className="text-center mb-12">
        <span className="text-xs font-semibold uppercase tracking-wider text-[#002FA7]">
          Veelgesteld
        </span>
        <h1 className="font-display text-5xl font-bold text-ink mt-3 tracking-tight">
          Alle vragen op een rij.
        </h1>
        <p className="text-ink-soft mt-3">
          Mis je iets? Mail ons op{" "}
          <a href="mailto:info@checkexpert.be" className="text-[#002FA7] font-semibold">
            info@checkexpert.be
          </a>
          .
        </p>
      </div>
      <Accordion type="single" collapsible className="space-y-3">
        {FAQS.map((item, i) => (
          <AccordionItem
            key={i}
            value={`faq-${i}`}
            className="bg-white border border-border rounded-2xl px-6"
          >
            <AccordionTrigger className="font-display text-lg font-semibold text-ink hover:no-underline py-5 text-left">
              {item.q}
            </AccordionTrigger>
            <AccordionContent className="text-ink-soft pb-5 leading-relaxed">
              {item.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
}
